import { MadSDKAPIError } from "../../../../errors/base";
export class BidstreamFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BidstreamFetchFailed);
        }
        this.name = "BidstreamFetchFailed";
        this.message = "Failed to fetch bidstream data. Please try again at a later time.";
    }
}
export class BidstreamTrendFetchFailed extends MadSDKAPIError {
    constructor(originalError) {
        super(originalError);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BidstreamTrendFetchFailed);
        }
        this.name = "BidstreamTrendFetchFailed";
        this.message = "Failed to fetch bidstream trend data. Please try again at a later time.";
    }
}
//# sourceMappingURL=errors.js.map